// extracted by mini-css-extract-plugin
export default {"wrapper":"TabMenu_wrapper","item":"TabMenu_item","active":"TabMenu_active"};